// Events
import { CART_STAGE_UPDATE, THEME_CART_UPDATED } from 'events';
import { component } from 'picoapp';

import { setCSSProperty } from 'utils/css';

// Utils
import choozy from 'utils/choozy';
import formatMoney from 'utils/format-money';
import getString from 'utils/string';

export default component((node, ctx) => {
  const { progressText } = choozy(node);

  const discountThreshold = parseInt(node.dataset.threshold, 10);

  const update = (cart) => {
    if (cart.requires_shipping === false) {
      node.hidden = true;
    } else {
      node.hidden = false;
    }

    node.classList[cart.original_total_price > discountThreshold ? 'add' : 'remove'](
      'threshold-reached',
    );
    setCSSProperty(node, '--cart-subtotal', cart.original_total_price / 100);

    progressText.textContent = getString('cart.discount_progress_text', {
      threshold_distance: formatMoney(
        Math.max(0, discountThreshold - cart.original_total_price),
      ).removeTrailingZeros(),
    });
  };

  ctx.on(THEME_CART_UPDATED, ({ cart }) => update(cart));

  ctx.on(CART_STAGE_UPDATE, (state, updatedCart) => update(updatedCart));
});
